module.exports = __webpack_public_path__ + "img/cloud-fail.2d2816f3.svg";